import { graphql, useStaticQuery } from 'gatsby'
import { useEffect } from 'react'

const useFetchAndStoreGlobalFilterableTaxonomyData = () => {
  const data = useStaticQuery(graphql`
    query {
      globalFilterableTaxonomy: allTaxonomy(
        filter: { is_filterable: { eq: true }, global: { eq: true } }
      ) {
        edges {
          node {
            title
            type
          }
        }
      }
    }
  `)

  useEffect(() => {
    if (!sessionStorage.getItem('globalFilterableTaxonomy')) {
      const taxonomyData = data.globalFilterableTaxonomy.edges.map(
        ({ node }) => node
      )
      sessionStorage.setItem(
        'globalFilterableTaxonomy',
        JSON.stringify(taxonomyData)
      )
    }
  }, [data])
}

export default useFetchAndStoreGlobalFilterableTaxonomyData
